import type { TopicData } from "../topic-data";

/**
 * The forward/right/up axes shared by Position and VectorField (and any
 * future component with the same shape). Each axis is either bound to
 * TopicData or set to a fixed numeric value.
 */
export interface Axes {
  forward: TopicData | number;
  right: TopicData | number;
  up: TopicData | number;
}

/**
 * Returns the file_id of any axis bound to TopicData, or `undefined` if every
 * axis is numeric (or `axes` is missing).
 *
 * Bound axes within a single component (Position, VectorField, ...) always
 * share a file, so any bound axis yields the answer. There is no axis
 * precedence.
 */
export function deriveSourceFileIdFromAxes(
  axes: Axes | undefined,
): string | undefined {
  if (!axes) {
    return undefined;
  }
  // Type predicate (`axis is TopicData`) narrows the find() result so we can
  // access boundAxis.topic below without a second runtime check for `number`.
  const boundAxis = [axes.forward, axes.right, axes.up].find(
    (axis): axis is TopicData => typeof axis !== "number",
  );
  if (boundAxis === undefined) {
    return undefined;
  }
  return boundAxis.topic.association.association_id;
}
